var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"seo-hidden",staticStyle:{"display":"none !important","visibility":"hidden !important"}},[_c('h1',[_vm._v(_vm._s(_vm.seoTitle)+" | IMME")]),_c('p',{staticClass:"lead"},[_vm._v(_vm._s(_vm.seoDescription))]),_c('p',[_vm._v(_vm._s(_vm.seoCanonical))])])
}
var staticRenderFns = []

export { render, staticRenderFns }